import { render, staticRenderFns } from "./LangSelect.vue?vue&type=template&id=059a2c04&scoped=true"
import script from "./LangSelect.vue?vue&type=script&lang=js"
export * from "./LangSelect.vue?vue&type=script&lang=js"
import style0 from "./LangSelect.vue?vue&type=style&index=0&id=059a2c04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059a2c04",
  null
  
)

export default component.exports